import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { RouteProps } from 'react-router';
import peopleImg from './img/img-content__people.jpg';

import './styles/style.css';
import './styles/custom.css';

const LandingPage: React.FC<RouteProps> = ({ location }) => {
  useEffect(() => {
    document.body.classList.add('landing');
    return () => {
      document.body.classList.remove('landing');
    }
  }, []);

  return (
    <React.Fragment>
      <section className="main-screen">
        <div className="container">
          {/* Логотип и кнопка */}
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-2 col-7 mt-4 pl-0">
              <svg className="main-screen__logo" width={197} height={31} viewBox="0 0 197 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M112.994 0.260817H110.32V11.781H119.309V14.3273H121.685L122.05 9.33638H120.022V0.260817H117.348V9.33196H112.999V0.260817H112.994ZM123.066 0.260817V11.781H131.704V9.45131H125.74V6.93597H130.01V4.65493H125.74V2.59049H131.704V0.260817H123.066ZM134.948 6.93597H136.958C138.086 6.93597 138.652 7.21889 138.652 8.26216C138.652 9.30543 138.086 9.58835 136.062 9.58835C135.063 9.58911 134.066 9.48389 133.09 9.27449L132.591 11.6395C133.944 11.894 135.318 12.0272 136.695 12.0374C140.069 12.0374 141.598 11.193 141.598 8.71307C141.598 6.91387 141.067 5.83966 138.875 5.73798C140.951 5.57442 141.348 4.59746 141.348 2.99277C141.348 0.782452 140.154 0 136.713 0C135.351 0.0088972 133.993 0.148054 132.657 0.41554L133.165 2.72311C134.125 2.51285 135.106 2.4076 136.089 2.40925C138.032 2.40925 138.5 2.67448 138.5 3.51882C138.5 4.44274 138.055 4.65935 136.922 4.65935H134.948V6.94039V6.93597ZM151.278 11.7987H154.237C152.989 8.79264 151.264 3.88132 150.168 0.2785H146.032C144.695 3.51882 142.912 8.57603 141.927 11.7987H144.784C144.985 11.0869 145.23 10.2117 145.533 9.25239H150.302C150.649 10.2293 151.001 11.1223 151.282 11.7987H151.278ZM148.158 2.59049C148.506 3.81501 149.005 5.38433 149.535 6.95366H146.21C146.741 5.34897 147.276 3.79732 147.721 2.59049H148.158ZM157.691 6.01206V2.54186H160.579C161.31 2.54186 161.711 3.05466 161.711 4.31012C161.711 5.56558 161.265 5.99438 160.548 5.99438L157.691 6.01206ZM157.691 11.7987V8.19143H161.497C163.659 8.19143 164.652 6.38781 164.652 4.3057C164.652 1.94066 163.855 0.256397 161.479 0.256397H155.017V11.781L157.691 11.7987ZM168.499 9.53531V6.22867H171.494C172.158 6.22867 172.59 6.67074 172.59 7.86431C172.59 9.05788 172.242 9.51762 171.525 9.51762L168.499 9.53531ZM165.825 0.2785V11.781H172.434C174.627 11.781 175.509 10.278 175.509 7.86431C175.509 5.73356 174.564 3.97857 172.389 3.97857H168.503V0.260817L165.825 0.2785Z" fill="#2B2A29" />
                <path d="M109.604 23.9223C109.604 28.6667 111.403 30.0874 115.136 30.0874C116.275 30.0856 117.411 29.9568 118.522 29.7032L118.005 27.2818C117.257 27.4889 116.484 27.5955 115.707 27.599C113.359 27.599 112.486 27.1523 112.486 23.9581C112.486 20.7639 113.359 20.3841 115.707 20.3841C116.484 20.3797 117.258 20.4865 118.005 20.7013L118.522 18.3291C117.415 18.0535 116.277 17.9125 115.136 17.9092C111.38 17.9092 109.604 19.1467 109.604 23.9089V23.9223ZM128.273 29.8506H131.255C129.995 26.8083 128.255 21.8494 127.148 18.2085H122.97C121.621 21.4831 119.822 26.5938 118.832 29.8506H121.715C121.918 29.1313 122.165 28.2468 122.471 27.2774H127.288C127.639 28.2647 127.994 29.1671 128.277 29.8506H128.273ZM125.125 20.545C125.475 21.7824 125.979 23.3684 126.514 24.9543H123.159C123.694 23.3326 124.234 21.7646 124.684 20.545H125.125ZM136.251 29.8506V20.5628H140.142V18.204H129.622V20.5584H133.53V29.8506H136.251ZM141.158 18.204V29.8506H149.875V27.4963H143.857V24.9588H148.166V22.6714H143.857V20.5628H149.875V18.204H141.158ZM158.492 20.5584V29.8506H161.19V18.204H153.009C152.825 22.4481 151.786 26.3883 150.644 29.8461H153.509C154.545 26.8406 155.216 23.7224 155.505 20.5584H158.492ZM170.244 20.5584V29.8506H172.942V18.204H164.757C164.573 22.4481 163.534 26.3883 162.391 29.8461H165.261C166.297 26.8403 166.967 23.7223 167.258 20.5584H170.244ZM185.468 18.204H182.158C180.714 20.8621 179.122 23.5649 177.512 26.1873V18.204H174.863V29.8506H178.398C179.905 27.4114 181.416 24.7711 182.792 22.1845V29.8506H185.459V18.204H185.468ZM193.114 29.8461V20.5628H197V18.204H186.507V20.5584H190.415V29.8506L193.114 29.8461Z" fill="#2B2A29" />
                <path d="M97.9874 0L81.6655 16.627V26.4031L108.069 0H97.9874Z" fill="#fdbc00" />
                <path d="M91.307 16.5786L78.2883 30.0872H87.8832L101.314 16.5786H91.307Z" fill="#d3222a" />
                <path d="M78.338 0L62.0161 16.627V26.4031L88.4192 0H78.338Z" fill="#fdbc00" />
                <path d="M71.6576 16.5786L58.6389 30.0872H68.2338L81.6648 16.5786H71.6576Z" fill="#d3222a" />
                <path d="M58.5 0L42.3679 16.627V26.4031L68.464 0H58.5Z" fill="#fdbc00" />
                <path d="M52.0094 16.5786L38.9907 30.0872H48.5856L62.0167 16.5786H52.0094Z" fill="#d3222a" />
                <path d="M39.158 0L23.0259 16.627V26.4031L49.1219 0H39.158Z" fill="#fdbc00" />
                <path d="M32.6673 16.5786L19.6487 30.0872H29.2435L42.6746 16.5786H32.6673Z" fill="#d3222a" />
                <path d="M19.5093 0L3.3772 16.627V26.4031L29.4733 0H19.5093Z" fill="#fdbc00" />
                <path d="M13.0187 16.5786L0 30.0872H9.59485L23.0259 16.5786H13.0187Z" fill="#d3222a" />
              </svg>
            </div>
            <div className="col-lg-2 col-4 mt-4 d-flex justify-content-end">
              <Link to="/auth/login" className="main-screen__entry">Войти</Link>
            </div>
          </div>
          {/* // логотип и кнопка */}
          {/* Текстовый блок и кнопка регистрации */}
          <div className="row">
            <div className="col-12 main-screen__image" />
            <div className="col-lg-5 col-sm-6 offset-lg-1">
              <article className="greetings greetings--main-screen">
                <h2 className="greetings__heading">Здравствуйте!</h2>
                <p className="greetings__text">Добро пожаловать на партнерский портал «Цезарь Сателлит».
                  Он специально создан для страховых агентов, которые хотят развиваться и зарабатывать.
              </p>
                <p className="greetings__text">
                  Партнерская программа позволяет активно зарабатывать
                и получать дополнительные пассивные доходы от продаж.</p>
                <Link
                  to={location!.pathname === '/landing' ? "/auth/registration" : "/auth/checkIn"} 
                  className="greetings__btn btn-check"
                >Регистрация</Link>
              </article>
            </div>
          </div>
          {/* //Текстовый блок и кнопка регистрации */}
        </div>
      </section>
      {/* Блок с картинкой и текстом */}
      <section className="partner-programm">
        <div className="container">
          <div className="row justify-content-md-around align-items-center pt-5">
            <div className="col-sm-6 col-lg-4 order-2 order-sm-1">
              <img className="partner-programm__img img-fluid" src={peopleImg} alt="Партнерская программа цезарь сателлит" />
            </div>
            <div className="col-sm-6 col-lg-6 pt-3 pt-md-0 order-1 order-sm-2">
              <article className="greetings">
                <h2 className="greetings__heading">Для кого подходит партнерская программа?</h2>
                <blockquote className="greetings__blockquote">Менеджеры и независимые агенты по&nbsp;продажам страховых продуктов.</blockquote>
              </article>
            </div>
          </div>
        </div>
      </section>
      {/* // Блок с картинкой и текстом */}
      {/* Feature block */}
      <section className="feature">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-4">
              <h2 className="feature__heading greetings__heading">Возможности для&nbsp;агентов</h2>
            </div>
          </div>
          <div className="row justify-content-md-around">
            <div className="col-sm-5 col-lg-4">
              <article className="feature__item box-content box-content--schedule">
                <div className="box-content__wrap">
                  <h4 className="box-content__heading">Высокий заработок</h4>
                  <p className="box-content__text">Большая комиссия с личных продаж и пассивный доход от привлеченных агентов. Повышенная комиссия на спец- предложения каждую неделю.</p>
                </div>
              </article>
            </div>
            <div className="col-sm-5 col-lg-4">
              <article className="feature__item box-content box-content--truck">
                <div className="box-content__wrap">
                  <h4 className="box-content__heading">Большой ассортимент</h4>
                  <p className="box-content__text">Более 100 товаров и услуг «Цезарь Сателлит» с высокой маржинальностью и специальными надбавками за реализацию акционных предложений.</p>
                </div>
              </article>
            </div>
          </div>
          <div className="row justify-content-md-around">
            <div className="col-sm-5 col-lg-4">
              <article className="feature__item box-content box-content--manager">
                <div className="box-content__wrap">
                  <h4 className="box-content__heading">Персональный менеджер</h4>
                  <p className="box-content__text">Каждому агенту предоставляется персональный менеджер, который решает организационные вопросы и консультирует по возникшим вопросам.</p>
                </div>
              </article>
            </div>
            <div className="col-sm-5 col-lg-4">
              <article className="feature__item box-content box-content--cabinet">
                <div className="box-content__wrap">
                  <h4 className="box-content__heading">Личный онлайн-кабинет</h4>
                  <p className="box-content__text">Индивидуальные предложения по&nbsp;товарам и услугам, ведение базы клиентов, история заказов, онлайн счет, вывод средств и еще более 50&nbsp;удобных инструментов.</p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
      {/* // Feature block */}
      {/* Team block */}
      <section className="team">
        <div className="container">
          <div className="row">
            <div className="col-10 col-lg-5 offset-lg-1">
              <article className="call">
                <h2 className="call__heading">Присоединяйтесь к&nbsp;нашей команде!</h2>
                <p className="call__text">Если вы читаете этот текст, значит наше предложение заинтересовало вас. Так зачем же терять время, когда можно начать зарабатывать прямо сейчас. Нажмите кнопку “Регистрация” и присоединитесь к более тысячи агентов, которые получают дополнительный доход в режиме реального времени.
              </p>
                <Link to="/auth/registration" className="call__btn btn-check">Регистрация</Link>
              </article>
            </div>
          </div>
        </div>
      </section>
      {/* // Team block */}
      {/* Work */}
      <section className="work">
        <div className="container lg-px-0">
          <div className="row justify-content-md-center">
            <div className="col-8 col-lg-5">
              <h2 className="feature__heading greetings__heading">Приемущества работы с&nbsp;нами</h2>
            </div>
          </div>
          <div className="row justify-content-md-around align-items-end">
            <div className="col-sm-5 col-lg-3">
              <article className="feature__item feature__item--column box-content box-content--model">
                <div className="box-content__wrap">
                  <h4 className="box-content__heading">Новая модель заработка</h4>
                  <p className="box-content__text">Система построена на платформе, которая увеличивает ваши личные продажи и развивает вашу собственную агентскую сеть.</p>
                </div>
              </article>
            </div>
            <div className="col-sm-5 col-lg-3">
              <article className="feature__item feature__item--column box-content box-content--service">
                <div className="box-content__wrap">
                  <h4 className="box-content__heading">Удобный сервис</h4>
                  <p className="box-content__text">Каждый агент может работать в&nbsp;системе с любого устройства из&nbsp;любой точки мира. Для этого достаточно выхода в интернет. </p>
                </div>
              </article>
            </div>
            <div className="col-sm-5 col-lg-3">
              <article className="feature__item feature__item--column box-content box-content--income">
                <div className="box-content__wrap">
                  <h4 className="box-content__heading">Нарастающий доход</h4>
                  <p className="box-content__text">Помимо собственных продаж, вы&nbsp;привлекаете новых агентов и&nbsp;клиентов, с которых всегда получаете комиссию.</p>
                </div>
              </article>
            </div>
            <div className="col-sm-5 col-lg-3">
              <article className="feature__item feature__item--column box-content box-content--sales">
                <div className="box-content__wrap">
                  <h4 className="box-content__heading">Автоматизация продаж</h4>
                  <p className="box-content__text">Вам достаточно отправить клиенту ссылку на интернет-магазин и на этом закончить работу. Клиент сам выберет и оплатит товары и услуги.</p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
      {/* //Work */}
      <footer className="main-footer">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-sm-6 col-lg-5">
              <p className="main-footer__copyright">© 2019 «Цезарь Сателлит». Все права защищены.</p>
            </div>
            <div className="col-12 col-sm-6 col-lg-5 d-flex justify-content-sm-end">
              <p className="main-footer__number">CSAT.RU 8 800 770 70 00</p>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default LandingPage;
